import React from 'react'

import { CommercialOnly } from '@/components/common/CommercialOnly'

import {
  NotificationFeed as ActiveNotificationFeed,
  type NotificationFeedProps,
} from '@/notifications'

export const NotificationFeed: React.FC<NotificationFeedProps> = (props) => (
  <CommercialOnly>
    <ActiveNotificationFeed {...props} />
  </CommercialOnly>
)
